export enum SessionStorage {
  TOKEN = 'token',
  PROFILE_ID = 'profile_id',
  USER_ID = 'user_id'
}
